import Papa from 'papaparse';

const prependCsvFileHeader = (csvData: string): string => {
  const header = 'data:text/csv;charset=utf-8,';
  return header + csvData;
};

export const convertArrayOfObjectsToCsvString = <T,>(data: Array<T>, delimeter: string): string => {
  if (data.length === 0) {
    return '';
  }

  return prependCsvFileHeader(
    Papa.unparse(data, {
      delimiter: delimeter,
    })
  );
};

export const getCurrentTimeFilenameSuffix = (): string => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const seconds = String(now.getSeconds()).padStart(2, '0');
  return `${year}${month}${day}_${hours}${minutes}${seconds}`;
};
